import React, { useState } from "react";

import { ClickAwayListener, makeStyles } from "@material-ui/core";
import { Picker } from "emoji-mart";

import MoodIcon from "@material-ui/icons/Mood";
import NoteIcon from "@material-ui/icons/Note";

import SeletorFigurinhas from "../SeletorFigurinhas";
import { filtroDeEmoji } from "../../utils/emojiSuportado";

const useStyles = makeStyles((theme) => ({
  caixa: {
    position: "absolute",
    bottom: 63,
    left: 8,
    zIndex: 1300,
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 6px 24px rgba(0,0,0,0.25)",
    backgroundColor: theme.palette.background.paper,
    width: 358,
  },
  corpo: {
    minHeight: 300,
  },
  abas: {
    display: "flex",
    justifyContent: "center",
    gap: 6,
    padding: 6,
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor:
      theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "#f7f9fa",
  },
  aba: {
    border: "none",
    background: "none",
    cursor: "pointer",
    borderRadius: 16,
    padding: "5px 20px",
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.secondary,
    transition: "all 0.15s",
    "&:hover": {
      backgroundColor:
        theme.palette.type === "dark" ? "rgba(255,255,255,0.08)" : "#e9edef",
    },
  },
  abaAtiva: {
    backgroundColor:
      theme.palette.type === "dark" ? "rgba(255,255,255,0.12)" : "#e9edef",
    color: "#1E9855",
  },
}));

const TRADUCAO = {
  search: "Pesquisar",
  clear: "Limpar",
  notfound: "Nenhum emoji encontrado",
  skintext: "Escolha seu tom de pele padrão",
  categories: {
    search: "Resultados da pesquisa",
    recent: "Recentes",
    smileys: "Smileys e Emoticons",
    people: "Pessoas e Corpo",
    nature: "Animais e Natureza",
    foods: "Alimentos e Bebidas",
    activity: "Atividades",
    places: "Viagens e Lugares",
    objects: "Objetos",
    symbols: "Símbolos",
    flags: "Bandeiras",
    custom: "Personalizados",
  },
  categorieslabel: "Categorias de Emojis",
};








const SeletorConteudo = ({
  aberto,
  onFechar,
  onEmoji,
  ticketId,
  onFigurinhaEnviada,
}) => {
  const classes = useStyles();
  const [aba, setAba] = useState("emoji");

  if (!aberto) return null;

  return (
    <ClickAwayListener onClickAway={onFechar}>
      <div className={classes.caixa}>
        <div className={classes.corpo}>
          {aba === "emoji" ? (
            <Picker
              native
              perLine={9}
              showPreview={false}
              showSkinTones={false}
              onSelect={onEmoji}
              i18n={TRADUCAO}
              color="#1E9855"
              // esconde o que a fonte do sistema nao consegue desenhar
              emojisToShowFilter={filtroDeEmoji}
              exclude={["flags"]}
              style={{ width: "100%", border: "none" }}
            />
          ) : (
            <SeletorFigurinhas
              aberto={aberto}
              ticketId={ticketId}
              onEnviado={() => {
                if (onFigurinhaEnviada) onFigurinhaEnviada();
                onFechar();
              }}
            />
          )}
        </div>

        <div className={classes.abas}>
          <button
            type="button"
            className={`${classes.aba} ${
              aba === "emoji" ? classes.abaAtiva : ""
            }`}
            onClick={() => setAba("emoji")}
            title="Emojis"
          >
            <MoodIcon fontSize="small" />
          </button>

          <button
            type="button"
            className={`${classes.aba} ${
              aba === "figurinhas" ? classes.abaAtiva : ""
            }`}
            onClick={() => setAba("figurinhas")}
            title="Figurinhas"
          >
            <NoteIcon fontSize="small" />
          </button>
        </div>
      </div>
    </ClickAwayListener>
  );
};

export default SeletorConteudo;
